import { useEffect, useMemo, useState } from 'react';
import {
  APP_STORE_URL,
  EMPTY_UTMS,
  UtmParams,
  buildPlayStoreUrl,
  captureStoreClick,
  readUtmParams,
} from './storeLinks';

export function useStoreLinks() {
  const [utms, setUtms] = useState<UtmParams>(EMPTY_UTMS);

  useEffect(() => {
    setUtms(readUtmParams(window.location.search));
  }, []);

  const playStoreUrl = useMemo(() => buildPlayStoreUrl(utms), [utms]);

  const onAppStoreClick = () => captureStoreClick('app_store_click', 'ios', utms);
  const onPlayStoreClick = () => captureStoreClick('play_store_click', 'android', utms);

  return {
    appStoreUrl: APP_STORE_URL,
    playStoreUrl,
    onAppStoreClick,
    onPlayStoreClick,
  };
}
